module.exports = __webpack_public_path__ + "static/media/ec.8fb69b79.svg";